module.exports = __webpack_public_path__ + "static/img/pay-stylepic4.d83577c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pay-stylepic4.jpg
// module id = d9Jo
// module chunks = 171